<div class="no-results" i18n *ngIf="hasDoneFirstQuery && videos.length === 0">{{ noResultMessage }}</div>

<div
  class="videos"
  myInfiniteScroller (nearOfBottom)="onNearOfBottom()" [dataObservable]="onDataSubject.asObservable()"
  [parentDisabled]="disabled" [setAngularState]="true"
>
  <div class="video" *ngFor="let video of videos; let i = index; trackBy: videoById">

    <div class="checkbox-container" *ngIf="enableSelection">
      <my-peertube-checkbox [inputName]="'video-check-' + video.id" [(ngModel)]="_selection[video.id]"></my-peertube-checkbox>
    </div>

    <my-video-miniature
      [containedInPlaylists]="videosContainedInPlaylists ? videosContainedInPlaylists[video.id] : undefined"
      [video]="video" [displayAsRow]="true" [displayOptions]="miniatureDisplayOptions"
      [displayVideoActions]="false" [user]="user"
    ></my-video-miniature>

    <!-- Display only once -->
    <div class="action-selection-mode" *ngIf="isInSelectionMode() === true && i === 0">
      <div class="action-selection-mode-child">
        <button i18n class="action-button action-button-cancel-selection" (click)="abortSelectionMode()">
          Cancel
        </button>

        <ng-container *ngTemplateOutlet="globalButtonsTemplate"></ng-container>
      </div>
    </div>

    <ng-container  *ngIf="isInSelectionMode() === false">
      <ng-container *ngTemplateOutlet="rowButtonsTemplate; context: {$implicit: video}"></ng-container>
    </ng-container>
  </div>
</div>
